var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalEarnings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.977,
    height: 23.928,
    viewBox: "0 0 23.977 23.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "piggy-bank",
    d: "M22.432,11.046A8.055,8.055,0,0,0,21,8.719V5a2,2,0,0,0-.764-1.576,1.97,1.97,0,0,0-1.681-.374A5.668,5.668,0,0,0,14.628,6H9.265A8.371,8.371,0,0,0,2.846,8.969.991.991,0,0,1,3,7,1,1,0,0,0,3,5a3,3,0,0,0-1.268,5.709A7.976,7.976,0,0,0,5,20.921V21a3.007,3.007,0,0,0,5.829,1h2.343A3.007,3.007,0,0,0,19,21v-.092a8.021,8.021,0,0,0,3.432-3.954A1.935,1.935,0,0,0,24,15V13A1.936,1.936,0,0,0,22.432,11.046ZM18,13a1,1,0,0,1,0-2A1,1,0,0,1,18,13ZM6.052,4.512C5.49-1.079,13.792-1.62,14,4H9.266A10.454,10.454,0,0,0,6.052,4.512Z",
    transform: "translate(-0.023 -0.043)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEarnings);
export default __webpack_public_path__ + "static/media/total-earnings.209537ce37c3cd5f04bd5f33fc4203f2.svg";
export { ForwardRef as ReactComponent };